import { MenuItem, Select } from "@mui/material";

const SupplyDivisionMenuItems = (supplyDivisions) => {  

  return supplyDivisions.map(supplyDivision => (
    <MenuItem value={supplyDivision.supplyDivisionId.toString()}>
      {supplyDivision.supplyDivisionName}
    </MenuItem>
  ));

}

function SupplyDivisionSelect({supplyDivisions, supplyDivisionValue, changeSupplyDivision}) {

  return (
    <Select
      value={supplyDivisionValue}
      onChange={(e, _) => changeSupplyDivision(e.target.value)}
      sx={{width: "300px"}}
    >
      {SupplyDivisionMenuItems(supplyDivisions)}
    </Select>    
  )
}

export default SupplyDivisionSelect;